import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

/**
 * Hook for accessing authentication state and actions.
 *
 * Returns: { user, loading, isAuthenticated, needsAgbReacceptance,
 *            requestMagicLink, verifyToken, logout, acceptAgb,
 *            sessionExpired, clearSessionExpired }
 */
const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default useAuth;
